export default {
  'marketplace.platform_code': 'Platform Code',
  'marketplace.reference_code': 'Reference Code',
  'marketplace.platform_name': 'Platform Name',
  'marketplace.order_priority': 'WMS Order Priority',
  'marketplace.pick_product_type_priority': 'Picking Product Type Priority',
  'marketplace.email': 'Email',
  'marketplace.first_pick_product_type': 'First Pick Product Type',
  'marketplace.second_pick_product_type': 'Second Pick Product Type',
  'marketplace.third_pick_product_type': 'Third Pick Product Type',
};
